import {
  apiRequest,
  P3KdetailP3K,
} from "../../../../../services/adapters/kepegawaian/dokumenP3KService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      P3KdetailP3K,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
